/**
 * 数据中心模拟数据
 * http://mockjs.com/
 */
import Mock from 'mockjs'
import cache from '../../common/cache'
let mock = cache.getSessionData('mock')
// mock 开关
let mockSwitch = mock ? '' : '_'

// 获取当前用户是否有权限查看集团范围数据
Mock.mock(/dc\/privilege/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'view_group': true,
    'store_id': 10
  },
  'message': 'ok'
})

Mock.mock(/dc\/car\/visits\/statistic\/daily/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    '2017-08-09': {
      'hours_detail': [
        {
          'workshop_visit_times': 0,
          'park_exit_times': 0,
          'hour': 0,
          'park_visit_times': 0
        },
        {
          'workshop_visit_times': 0,
          'park_exit_times': 0,
          'hour': 1,
          'park_visit_times': 0
        },
        {
          'workshop_visit_times': 0,
          'park_exit_times': 0,
          'hour': 2,
          'park_visit_times': 0
        },
        {
          'workshop_visit_times': 0,
          'park_exit_times': 0,
          'hour': 3,
          'park_visit_times': 0
        },
        {
          'workshop_visit_times': 0,
          'park_exit_times': 0,
          'hour': 4,
          'park_visit_times': 0
        },
        {
          'workshop_visit_times': 0,
          'park_exit_times': 0,
          'hour': 5,
          'park_visit_times': 0
        },
        {
          'workshop_visit_times': 0,
          'park_exit_times': 0,
          'hour': 6,
          'park_visit_times': 0
        },
        {
          'workshop_visit_times': 0,
          'park_exit_times': 0,
          'hour': 7,
          'park_visit_times': 0
        },
        {
          'workshop_visit_times': 0,
          'park_exit_times': 0,
          'hour': 8,
          'park_visit_times': 0
        },
        {
          'workshop_visit_times': 0,
          'park_exit_times': 0,
          'hour': 9,
          'park_visit_times': 0
        },
        {
          'workshop_visit_times': 0,
          'park_exit_times': 1,
          'hour': 10,
          'park_visit_times': 2
        },
        {
          'workshop_visit_times': 0,
          'park_exit_times': 1,
          'hour': 11,
          'park_visit_times': 1
        },
        {
          'workshop_visit_times': 0,
          'park_exit_times': 0,
          'hour': 12,
          'park_visit_times': 0
        },
        {
          'workshop_visit_times': 0,
          'park_exit_times': 0,
          'hour': 13,
          'park_visit_times': 0
        },
        {
          'workshop_visit_times': 0,
          'park_exit_times': 0,
          'hour': 14,
          'park_visit_times': 0
        },
        {
          'workshop_visit_times': 0,
          'park_exit_times': 0,
          'hour': 15,
          'park_visit_times': 1
        },
        {
          'workshop_visit_times': 0,
          'park_exit_times': 0,
          'hour': 16,
          'park_visit_times': 0
        },
        {
          'workshop_visit_times': 0,
          'park_exit_times': 0,
          'hour': 17,
          'park_visit_times': 0
        },
        {
          'workshop_visit_times': 0,
          'park_exit_times': 0,
          'hour': 18,
          'park_visit_times': 0
        },
        {
          'workshop_visit_times': 0,
          'park_exit_times': 0,
          'hour': 19,
          'park_visit_times': 0
        },
        {
          'workshop_visit_times': 0,
          'park_exit_times': 0,
          'hour': 20,
          'park_visit_times': 0
        },
        {
          'workshop_visit_times': 0,
          'park_exit_times': 0,
          'hour': 21,
          'park_visit_times': 0
        },
        {
          'workshop_visit_times': 0,
          'park_exit_times': 0,
          'hour': 22,
          'park_visit_times': 0
        },
        {
          'workshop_visit_times': 0,
          'park_exit_times': 0,
          'hour': 23,
          'park_visit_times': 0
        }
      ],
      'stores_detail': [
        // {
        //   'cars_count': 3,
        //   'workshop_visit_times': 0,
        //   'park_exit_times': 2,
        //   'name': '\u4e2d\u5347\u4e4b\u5bb6\u6d4b\u8bd5\u5e97',
        //   'store_id': 9,
        //   'park_visit_times': 4
        // },
        // {
        //   'cars_count': 3,
        //   'workshop_visit_times': 0,
        //   'park_exit_times': 2,
        //   'name': '\u5408\u8ba1',
        //   'store_id': null,
        //   'park_visit_times': 4
        // }
        {
          'store_id': 9,
          'store_name': '中升测试环境店',
          'park_visit_cars': 2, // 进店车辆
          'park_visit_times': 4, // 进店车次
          'workshop_visit_cars': 3, // 进车间车辆
          'workshop_visit_times': 0, // 进车间车次
          'park_exit_cars': 3, // 离店车辆
          'park_exit_times': 3 // 离店车次
        },
        {
          'store_id': null,
          'store_name': '合计',
          'park_visit_times': 114,
          'park_visit_cars': 112,
          'workshop_visit_times': 110,
          'workshop_visit_cars': 113,
          'park_exit_cars': 113,
          'park_exit_times': 113
        }
      ],
      'exit_components': {
        'total': 100,
        // 审批放行
        'normal_exit': {
          'total': 60, // 合计
          'sales_car_exit': 30, // 销售放行
          'service_car_exit': 20, // 售后放行
          'other': 10 // 其他审批放行
        },
        // 异常放行
        'abnormal_exit': {
          'total': 35, // 合计
          'whitelist': 20, // 白名单
          'blacklist': 10, // 黑名单
          'other': 5 // 其他异常放行
        },
        // 免放行
        'no_process_exit': {
          'total': 5
        }
      }
    }
  },
  'message': 'ok'
})

Mock.mock(/dc\/car\/visits\/statistic\/monthly/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    '2017-08-09': {
      'days_detail': [
        {
          'date': '2017-07-01',
          'workshop_visit_times': 0,
          'park_exit_times': 0,
          'park_visit_times': 0
        },
        {
          'date': '2017-07-02',
          'workshop_visit_times': 0,
          'park_exit_times': 0,
          'park_visit_times': 0
        },
        {
          'date': '2017-07-03',
          'workshop_visit_times': 0,
          'park_exit_times': 0,
          'park_visit_times': 0
        },
        {
          'date': '2017-07-04',
          'workshop_visit_times': 0,
          'park_exit_times': 0,
          'park_visit_times': 0
        },
        {
          'date': '2017-07-05',
          'workshop_visit_times': 0,
          'park_exit_times': 0,
          'park_visit_times': 0
        },
        {
          'date': '2017-07-06',
          'workshop_visit_times': 0,
          'park_exit_times': 12,
          'park_visit_times': 18
        },
        {
          'date': '2017-07-07',
          'workshop_visit_times': 0,
          'park_exit_times': 4,
          'park_visit_times': 5
        },
        {
          'date': '2017-07-08',
          'workshop_visit_times': 0,
          'park_exit_times': 1,
          'park_visit_times': 2
        },
        {
          'date': '2017-07-09',
          'workshop_visit_times': 0,
          'park_exit_times': 0,
          'park_visit_times': 0
        },
        {
          'date': '2017-07-10',
          'workshop_visit_times': 0,
          'park_exit_times': 0,
          'park_visit_times': 2
        },
        {
          'date': '2017-07-11',
          'workshop_visit_times': 0,
          'park_exit_times': 0,
          'park_visit_times': 0
        },
        {
          'date': '2017-07-12',
          'workshop_visit_times': 0,
          'park_exit_times': 0,
          'park_visit_times': 0
        },
        {
          'date': '2017-07-13',
          'workshop_visit_times': 0,
          'park_exit_times': 2,
          'park_visit_times': 4
        },
        {
          'date': '2017-07-14',
          'workshop_visit_times': 0,
          'park_exit_times': 0,
          'park_visit_times': 0
        },
        {
          'date': '2017-07-15',
          'workshop_visit_times': 0,
          'park_exit_times': 0,
          'park_visit_times': 0
        },
        {
          'date': '2017-07-16',
          'workshop_visit_times': 0,
          'park_exit_times': 0,
          'park_visit_times': 0
        },
        {
          'date': '2017-07-17',
          'workshop_visit_times': 0,
          'park_exit_times': 0,
          'park_visit_times': 0
        },
        {
          'date': '2017-07-18',
          'workshop_visit_times': 0,
          'park_exit_times': 0,
          'park_visit_times': 0
        },
        {
          'date': '2017-07-19',
          'workshop_visit_times': 0,
          'park_exit_times': 0,
          'park_visit_times': 0
        },
        {
          'date': '2017-07-20',
          'workshop_visit_times': 0,
          'park_exit_times': 0,
          'park_visit_times': 0
        },
        {
          'date': '2017-07-21',
          'workshop_visit_times': 0,
          'park_exit_times': 0,
          'park_visit_times': 0
        },
        {
          'date': '2017-07-22',
          'workshop_visit_times': 0,
          'park_exit_times': 0,
          'park_visit_times': 0
        },
        {
          'date': '2017-07-23',
          'workshop_visit_times': 0,
          'park_exit_times': 0,
          'park_visit_times': 0
        },
        {
          'date': '2017-07-24',
          'workshop_visit_times': 0,
          'park_exit_times': 0,
          'park_visit_times': 0
        },
        {
          'date': '2017-07-25',
          'workshop_visit_times': 0,
          'park_exit_times': 0,
          'park_visit_times': 0
        },
        {
          'date': '2017-07-26',
          'workshop_visit_times': 0,
          'park_exit_times': 0,
          'park_visit_times': 0
        },
        {
          'date': '2017-07-27',
          'workshop_visit_times': 0,
          'park_exit_times': 0,
          'park_visit_times': 0
        }
      ],
      'stores_detail': [
        // {
        //   'cars_count': 18,
        //   'workshop_visit_times': 0,
        //   'park_exit_times': 19,
        //   'name': '\u4e2d\u5347\u4e4b\u5bb6\u6d4b\u8bd5\u5e97',
        //   'store_id': 10,
        //   'park_visit_times': 31
        // },
        // {
        //   'cars_count': 18,
        //   'workshop_visit_times': 0,
        //   'park_exit_times': 19,
        //   'name': '\u5408\u8ba1',
        //   'store_id': null,
        //   'park_visit_times': 31
        // }
        {
          'store_id': 9,
          'store_name': '中升测试环境店',
          'park_visit_cars': 22, // 进店车辆
          'park_visit_times': 24, // 进店车次
          'workshop_visit_cars': 23, // 进车间车辆
          'workshop_visit_times': 0, // 进车间车次
          'park_exit_cars': 23, // 离店车辆
          'park_exit_times': 23 // 离店车次
        },
        {
          'store_id': null,
          'store_name': '合计',
          'park_visit_times': 24,
          'park_visit_cars': 22,
          'workshop_visit_times': 0,
          'workshop_visit_cars': 23,
          'park_exit_cars': 23,
          'park_exit_times': 23
        }
      ],
      'exit_components': {
        'total': 500,
        // 审批放行
        'normal_exit': {
          'total': 400, // 合计
          'sales_car_exit': 250, // 销售放行
          'service_car_exit': 50, // 售后放行
          'other': 100 // 其他审批放行
        },
        // 异常放行
        'abnormal_exit': {
          'total': 90, // 合计
          'whitelist': 50, // 白名单
          'blacklist': 20, // 黑名单
          'other': 20 // 其他异常放行
        },
        // 免放行
        'no_process_exit': {
          'total': 10
        }
      }
    }
  },
  'message': 'ok'
})

Mock.mock(/dc\/fans\/statistic\/daily/, 'get' + mockSwitch, {
  'code': 0, // 0 成功，其它表示失败
  'message': 'ok', // 错误信息
  'data': {
    '2017-07-26': { // 以所查询日期为Key
      'stores_detail': [{
        'name': '门店A', // 门店名称
        'store_id': 9, // 门店ID
        'total_fans': 30, // 粉丝总数
        'subscribed': 9, // 新增关注
        'unsubscribed': 3, // 取消关注
        'total_boud': 29, // 绑定总数
        'bound': 2 // 新增绑定
      }, {
        'name': '合计', // 门店名称
        'store_id': null, // 门店ID
        'total_fans': 30, // 粉丝总数
        'subscribed': 9, // 新增关注
        'unsubscribed': 3, // 取消关注
        'total_boud': 29, // 绑定总数
        'bound': 2 // 新增绑定
      }],
      'total': {
        'total_fans': 265, // 粉丝总数
        'subscribed': 9, // 新增关注
        'unsubscribed': 3, // 取消关注
        'total_boud': 29, // 绑定总数
        'bound': 2 // 新增绑定
      }
    }
  }
})

Mock.mock(/dc\/fans\/statistic\/monthly/, 'get' + mockSwitch, {
  'code': 0, // 0 成功，其它表示失败
  'message': 'ok', // 错误信息
  'data': {
    '2017-07-31': { // 以所查询日期为Key
      'days_detail': [{
        'total_fans': 30, // 粉丝总数
        'subscribed': 9, // 新增关注
        'unsubscribed': 3, // 取消关注
        'total_boud': 29, // 绑定总数
        'date': '2017-07-26', // 日期
        'bound': 2 // 新增绑定
      }],
      'stores_detail': [{
        'name': '门店A', // 门店名称
        'store_id': 9, // 门店ID
        'total_fans': 30, // 粉丝总数
        'subscribed': 9, // 新增关注
        'unsubscribed': 3, // 取消关注
        'total_boud': 29, // 绑定总数
        'bound': 2 // 新增绑定
      }, {
        'name': '合计', // 门店名称
        'store_id': null, // 门店ID
        'total_fans': 30, // 粉丝总数
        'subscribed': 9, // 新增关注
        'unsubscribed': 3, // 取消关注
        'total_boud': 29, // 绑定总数
        'bound': 2 // 新增绑定
      }],
      'total': {
        'total_fans': 50, // 粉丝总数
        'subscribed': 18, // 新增关注
        'unsubscribed': 6, // 取消关注
        'total_boud': 60, // 绑定总数
        'bound': 4 // 新增绑定
      }
    }
  }
})

Mock.mock(/dc\/insurances\/statistic\/daily\/\d+/, 'get' + mockSwitch, {
  'code': 0, // 0 成功，其它表示失败
  'message': 'ok', // 错误信息
  'data': {
    'name': '门店A', // 门店名称
    'store_id': 9, // 门店ID
    '2017-12-05': { // 以所查询日期为Key
      'assignees_detail': [{
        'name': '续保员A', // 续保员名称
        'employee_id': 1, // 续保员ID
        'ins_tickets_follow_count': 30, // 待跟进客户
        'ins_quotes_count': 9, // 报价数
        'ins_orders_count': 3, // 保单合计
        'ins_premiums_total': 29 // 保费合计
      }, {
        'name': '续保员B', // 续保员名称
        'employee_id': 2, // 续保员ID
        'ins_tickets_follow_count': 40, // 待跟进客户
        'ins_quotes_count': 109, // 报价数
        'ins_orders_count': 8, // 保单合计
        'ins_premiums_total': 39 // 保费合计
      }, {
        'name': '合计', // 门店名称
        'employee_id': null, // 续保员ID
        'ins_tickets_follow_count': 30, // 待跟进客户
        'ins_quotes_count': 9, // 报价数
        'ins_orders_count': 3, // 保单合计
        'ins_premiums_total': 29 // 保费合计
      }],
      'total': {
        'ins_enquiries_count': 30, // 询价数
        'ins_quotes_count': 9, // 报价数
        'ins_expr_paid': 2, // 当日进店预计续回
        'ins_orders_count': 3, // 保单合计
        'ins_premiums_total': 30000, // 保费合计，单位：分
        'ins_premiums_avg': 10000 // 保单均价，单位：分
      }
    }
  }
})

Mock.mock(/dc\/insurances\/statistic\/daily/, 'get' + mockSwitch, {
  'code': 0, // 0 成功，其它表示失败
  'message': 'ok', // 错误信息
  'data': {
    '2017-12-04': { // 以所查询日期为Key
      'stores_detail': [{
        'name': '门店A', // 门店名称
        'store_id': 9, // 门店ID
        'ins_enquiries_count': 30, // 询价数
        'ins_quotes_count': 9, // 报价数
        'ins_orders_count': 3, // 保单合计
        'ins_premiums_total': 29 // 保费合计
      }, {
        'name': '合计', // 门店名称
        'store_id': null, // 门店ID
        'ins_enquiries_count': 30, // 询价数
        'ins_quotes_count': 9, // 报价数
        'ins_orders_count': 3, // 保单合计
        'ins_premiums_total': 29 // 保费合计，单位：分
      }],
      'total': {
        'ins_enquiries_count': 30, // 询价数
        'ins_quotes_count': 9, // 报价数
        'ins_expr_paid': 2, // 当日进店预计续回
        'ins_orders_count': 3, // 保单合计
        'ins_premiums_total': 30000, // 保费合计，单位：分
        'ins_premiums_avg': 10000 // 保单均价，单位：分
      }
    }
  }
})

Mock.mock(/dc\/insurances\/statistic\/monthly\/\d+/, 'get' + mockSwitch, {
  'code': 0, // 0 成功，其它表示失败
  'message': 'ok', // 错误信息
  'data': {
    'name': '门店A', // 门店名称
    'store_id': 9, // 门店ID
    '2017-12': { // 以所查询月份为Key
      'assignees_detail': [{
        'name': '续保员A', // 续保员名称
        'employee_id': 1, // 续保员ID
        'ins_expires_count': 30, // 到期客户数
        'ins_quoted': 9, // 已报价数
        'ins_completed': 9, // 已续回
        'ins_completed_rate': 0.009, // 续回率（需自己转换成%显示）
        'ins_orders_count': 3, // 保单合计
        'ins_premiums_total': 29, // 保费合计
        'ins_premiums_avg': 10000 // 保单均价，单位：分
      }, {
        'name': '合计', // 续保员名称
        'employee_id': null, // 续保员ID
        'ins_expires_count': 30, // 到期客户数
        'ins_quoted': 9, // 已报价数
        'ins_completed': 9, // 已续回
        'ins_completed_rate': 0.009, // 续回率（需自己转换成%显示）
        'ins_orders_count': 3, // 保单合计
        'ins_premiums_total': 29, // 保费合计
        'ins_premiums_avg': 10000 // 保单均价，单位：分
      }],
      'customer_rating_detail': [{
        'name': 'A类客户', // 客户类型
        'ins_expires_count': 30, // 到期客户数
        'ins_completed': 9, // 已续回
        'ins_completed_rate': 0.009, // 续回率（需自己转换成%显示）
        'ins_orders_count': 3, // 保单合计
        'ins_premiums_total': 29, // 保费合计
        'ins_premiums_avg': 10000 // 保单均价，单位：分
      }, {
        'name': '合计', // 客户类型
        'ins_expires_count': 30, // 到期客户数
        'ins_completed': 9, // 已续回
        'ins_completed_rate': 0.009, // 续回率（需自己转换成%显示）
        'ins_orders_count': 3, // 保单合计
        'ins_premiums_total': 29, // 保费合计
        'ins_premiums_avg': 10000 // 保单均价，单位：分
      }],
      'ins_companies_detail': [{
        'name': '保险公司A', // 保险公司
        'ins_orders_count': 3, // 保单合计
        'ins_premiums_total': 29, // 保费合计，单位：分
        'order_rate': 0.33, // 保单占比（需自己转换成%显示）
        'premium_rate': 0.66 // 保费占比（需自己转换成%显示）
      }, {
        'name': '合计', // 客户类型
        'ins_orders_count': 3, // 保单合计
        'ins_premiums_total': 29, // 保费合计，单位：分
        'order_rate': 0.33, // 保单占比（需自己转换成%显示）
        'premium_rate': 0.66 // 保费占比（需自己转换成%显示）
      }],
      'commercial_ins_detail': [{
        'name': '机动车第三者责任保险', // 险种名称
        'ins_orders_count': 3, // 关联保单数
        'order_rate': 0.33 // 保单占比（需自己转换成%显示）
      }, {
        'name': '机动车第三者责任保险', // 险种名称
        'ins_orders_count': 3, // 关联保单数
        'order_rate': 0.33 // 保单占比（需自己转换成%显示）
      }, {
        'name': '机动车第三者责任保险', // 险种名称
        'ins_orders_count': 3, // 关联保单数
        'order_rate': 0.33 // 保单占比（需自己转换成%显示）
      }, {
        'name': '机动车第三者责任保险', // 险种名称
        'ins_orders_count': 3, // 关联保单数
        'order_rate': 0.33 // 保单占比（需自己转换成%显示）
      }],
      'total': {
        'ins_expires_count': 30, // 到期客户数
        'ins_quoted': 9, // 已报价数
        'ins_completed': 9, // 已续回
        'ins_completed_rate': 0.009, // 续回率（需自己转换成%显示）
        'ins_orders_count': 3, // 保单合计
        'ins_premiums_total': 490000000, // 保费合计
        'ins_premiums_avg': 10000 // 保单均价，单位：分
      }
    }
  }
})

Mock.mock(/dc\/insurances\/statistic\/monthly/, 'get' + mockSwitch, {
  'code': 0, // 0 成功，其它表示失败
  'message': 'ok', // 错误信息
  'data': {
    '2017-10-08': { // 以所查询月份为Key
      'stores_detail': [{
        'name': '中升之家测试号南山分店大冲商务中心', // 门店名称
        'ins_cars_count': 1000, // 保有车辆
        'store_id': 9, // 门店ID
        'ins_expires_count': 30, // 到期客户数
        'ins_quoted': 9, // 已报价数
        'ins_completed': 9, // 已续回
        'ins_completed_rate': 0.009, // 续回率（需自己转换成%显示）
        'ins_orders_count': 3, // 保单合计
        'ins_premiums_total': 29, // 保费合计
        'ins_premiums_avg': 10000 // 保单均价，单位：分
      }, {
        'name': '门店B', // 门店名称
        'ins_cars_count': 1000, // 保有车辆
        'store_id': 9, // 门店ID
        'ins_expires_count': 30, // 到期客户数
        'ins_quoted': 9, // 已报价数
        'ins_completed': 9, // 已续回
        'ins_completed_rate': 0.009, // 续回率（需自己转换成%显示）
        'ins_orders_count': 3, // 保单合计
        'ins_premiums_total': 29, // 保费合计
        'ins_premiums_avg': 10000 // 保单均价，单位：分
      }, {
        'name': '合计', // 门店名称
        'store_id': null, // 门店ID
        'ins_cars_count': 2000, // 保有车辆
        'ins_expires_count': 60, // 到期客户数
        'ins_quoted': 18, // 已报价数
        'ins_completed': 18, // 已续回
        'ins_completed_rate': 0.009, // 续回率（需自己转换成%显示）
        'ins_orders_count': 3, // 保单合计
        'ins_premiums_total': 29, // 保费合计
        'ins_premiums_avg': 10000 // 保单均价，单位：分
      }],
      'total': {
        'ins_expires_count': 30, // 到期客户数
        'ins_quoted': 9, // 已报价数
        'ins_completed': 9, // 已续回
        'ins_completed_rate': 0.009, // 续回率（需自己转换成%显示）
        'ins_orders_count': 3, // 保单合计
        'ins_premiums_total': 190000000, // 保费合计
        'ins_premiums_avg': 10000 // 保单均价，单位：分
      }
    }
  }
})
Mock.mock(/zs-used-car\/daily_stat/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'today': {
      'car_visit': {
        'sales': {
          'appraised': 3, // 评估数
          'appraised_rate': 0.0588, // 评估占比,假如占比是%5，返回0.05 ,
          'car_release': 1, // 放行车辆数
          'satisfy_solicit_rule': 2 // 符合招揽数
        },
        'service': {
          'appraised': 30,
          'appraised_rate': 0.06,
          'car_release': 10,
          'satisfy_solicit_rule': 20
        }
      },
      'source': {
        'internal': 0,
        'mp': 0,
        'sales': 0,
        'service': 13,
        'total': 13
      },
      'summary': {
        'appraised': 3,
        'avg_price': 1000000,
        'closed': 5,
        'finished': 4,
        'pending_appraise': 2,
        'pending_contact': 1
      },
      'date': '2016-11-02'
    },
    'yesterday': {
      'car_visit': {
        'sales': {
          'appraised': 0,
          'appraised_rate': 0,
          'car_release': 0,
          'satisfy_solicit_rule': 0
        },
        'service': {
          'appraised': 0,
          'appraised_rate': 0,
          'car_release': 0,
          'satisfy_solicit_rule': 0
        }
      },
      'source': {
        'internal': 24,
        'mp': 12,
        'sales': 13,
        'service': 14,
        'total': 15
      },
      'summary': {
        'appraised': 3,
        'avg_price': 20.30,
        'closed': 2,
        'finished': 1
      },
      'date': '2016-11-01'
    }
  },
  'message': 'ok'
})

Mock.mock(/zs-used-car\/monthly_stat/, 'get' + mockSwitch, {
  'code': 0,
  'data': {
    'last_month': {
      'car_visit': {
        'sales': {
          'appraised': 10,
          'appraised_rate': 20,
          'car_release': 30,
          'satisfy_solicit_rule': 40
        },
        'service': {
          'appraised': 50,
          'appraised_rate': 60,
          'car_release': 70,
          'satisfy_solicit_rule': 80
        }
      },
      'source': {
        'internal': {
          'appraised': 80,
          'finished': 100,
          'finished_rate': 1,
          'used_car': 12
        },
        'mp': { // 服务号
          'appraised': 10,
          'finished': 10,
          'finished_rate': 10,
          'used_car': 25
        },
        'sales': {
          'appraised': 3,
          'finished': 4,
          'finished_rate': 5,
          'used_car': 14
        },
        'service': {
          'appraised': 7,
          'finished': 8,
          'finished_rate': 9,
          'used_car': 19
        },
        'total': {
          'appraised': 12,
          'finished': 13,
          'finished_rate': 14,
          'used_car': 70
        }
      },
      'summary': {
        'appraised': 16,
        'avg_price': 17,
        'closed': 18,
        'finished': 19
      },
      'month': '2016-10'
    },
    'this_month': {
      'car_visit': {
        'sales': {
          'appraised': 21,
          'appraised_rate': 22,
          'car_release': 24,
          'satisfy_solicit_rule': 23
        },
        'service': {
          'appraised': 25,
          'appraised_rate': 26,
          'car_release': 27,
          'satisfy_solicit_rule': 28
        }
      },
      'source': {
        'internal': {
          'appraised': 29,
          'finished': 31,
          'finished_rate': 32,
          'used_car': 0
        },
        'mp': {
          'appraised': 34,
          'finished': 35,
          'finished_rate': 36,
          'used_car': 0
        },
        'sales': {
          'appraised': 420,
          'finished': 240,
          'finished_rate': 60,
          'used_car': 0
        },
        'service': {
          'appraised': 380,
          'finished': 390,
          'finished_rate': 410,
          'used_car': 0
        },
        'total': {
          'appraised': 43,
          'finished': 44,
          'finished_rate': null,
          'used_car': 0
        }
      },
      'summary': {
        'appraised': 47,
        'avg_price': 48,
        'closed': 49,
        'finished': 52
      },
      'month': '2016-11'
    }
  },
  'message': 'ok'
})
